import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { blogPosts } from './blog/posts';
export function LatestBlogPosts() {
  // Get the 3 most recent posts
  const recentPosts = blogPosts.slice(0, 3);
  return <section className="py-20 bg-brand-50/30" data-id="element-1939" data-mp="1fsyu5cajy66h">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1940" data-mp="1arj8pj4gpxnk">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-4" data-id="element-1941" data-mp="1au5jrsqkavaj">
          <div data-id="element-1942" data-mp="n41pibz9k7w7">
            <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-1943" data-mp="i3dnywdes8nq">
              Latest from Our Blog
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl" data-id="element-1944" data-mp="w3y5zqbi20g6">
              Read our latest articles on nutrition, food marketing, and how to
              make smarter grocery choices.
            </p>
          </div>
          <Link to="/blog" className="inline-flex items-center text-brand-600 font-bold hover:text-brand-700 transition-colors" data-id="element-1945" data-mp="27gh4n4ny81mb">
            View All Posts <ArrowRight className="w-4 h-4 ml-2" data-id="element-1946" data-mp="2secqj363qevd" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-1947" data-mp="2xdzd437tl7gu">
          {recentPosts.map(post => <Link key={post.slug} to={`/blog/${post.slug}`} className="group bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col" data-id="element-1948" data-mp="31fkn9gsyz7nc">
              <div className="relative h-48 overflow-hidden" data-id="element-1949" data-mp="29mtph1vn1avz">
                <img src={post.image} alt={post.imageAlt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1950" data-mp="2drjgodfcq1ak" />
                <span aria-hidden="true" className="pointer-events-none absolute bottom-2 right-2 select-none rounded-full bg-white/70 px-2 py-0.5 text-[10px] font-black tracking-tight backdrop-blur-sm" data-id="element-1951" data-mp="2nhmcelduxtcl">
                  <span className="text-slate-900/70" data-id="element-1952" data-mp="2ya4il5w3g1mo">Intelli</span>
                  <span className="text-brand-600/80" data-id="element-1953" data-mp="2tbupd0txjb3p">Eats</span>
                </span>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-1954" data-mp="372zsicwialis">
                <div className="flex items-center gap-3 mb-3" data-id="element-1955" data-mp="372g8mqnapn24">
                  <span className="px-2.5 py-1 rounded-full bg-brand-50 text-brand-700 text-xs font-bold tracking-wider uppercase" data-id="element-1956" data-mp="331e886hn74yk">
                    {post.category}
                  </span>
                  <span className="flex items-center text-xs text-slate-400" data-id="element-1957" data-mp="2adqr51fkywgo">
                    <Clock className="w-3 h-3 mr-1" data-id="element-1958" data-mp="2oci2wh6z061n" />
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-brand-600 transition-colors line-clamp-2" data-id="element-1959" data-mp="2jclvs92z7yhv">
                  {post.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3 flex-grow" data-id="element-1960" data-mp="3utc0fnrr4i9d">
                  {post.excerpt}
                </p>
                <span className="inline-flex items-center text-sm font-semibold text-brand-600 group-hover:text-brand-700 mt-auto" data-id="element-1961" data-mp="76jdb3us0bw8">
                  Read Article{' '}
                  <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-1962" data-mp="3tcyfff5y4bev" />
                </span>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}